import { graphql } from '@client/graphql/types';
import { useQuery } from '@apollo/client';

export const QUERY = graphql(`
  query GetHappyHours($branchId: ID!) {
    getHappyHours(branchId: $branchId) {
      id
      deliveryType
      discountType
      discountAmount
      minimumOrderAmount
      isActive

      timeRule {
        __typename
        ... on MenuSectionAlwaysTimeRule {
          type
        }

        __typename
        ... on MenuSectionRangeTimeRule {
          type
          start
          end
          daysOfWeek
          isAllDays
        }
      }
    }
  }
`);

export default function useGetHappyHours(branchId: string) {
  return useQuery(QUERY, { variables: { branchId } });
}
